import {Component, NgModule, OnInit} from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import {MainComponent} from '../manual/main/main.component';
import {routing} from '../manual/manual.routing';
import {LinksComponent} from '../manual/links/links.component';


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})

// @NgModule({
//   imports: [
//     SharedModule
//   ],
// })



export class NavigationComponent implements OnInit {

  public type: string;
  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.component.ts